import React from "react";
import Dashboard from "../../src/Dashboard/containers/Dashboard";
import { Box } from "@mui/material";

const SubApp = ({ dashboardItem, dashboardCount }) => {
  return (
    // <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: "100%", minHeight: "800px" }}>
    <Dashboard
      systemId={dashboardItem.deviceId}
      solutionType={dashboardItem.solutionType}
      systemName={dashboardItem.deviceName}
      dashboardCount={dashboardCount}
    />
    // </Box>
  );
};

export default SubApp;
